import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {IonicModule} from '@ionic/angular';
import {SmContainerListItemModule} from '../sm-container-list-item/sm-container-list-item.module';
import {SmGlobalSearchContainerResultComponent} from './sm-global-search-container-result.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    SmContainerListItemModule,
  ],
  declarations: [SmGlobalSearchContainerResultComponent],
  exports: [SmGlobalSearchContainerResultComponent],
})
export class SmGlobalSearchContainerResultModule {}
